// Русский язык
export default {
	status: {
		400: "Ошибка запроса! Пожалуйста, попробуйте еще раз позже",
		401: "Истекла сессия входа! Пожалуйста, войдите снова",
		403: "У текущего аккаунта нет разрешения на доступ",
		404: "Ресурс, к которому вы пытаетесь получить доступ, не существует",
		405: "Неправильный метод запроса! Пожалуйста, попробуйте еще раз позже",
		408: "Время запроса истекло! Пожалуйста, попробуйте еще раз позже",
		500: "Сервис столкнулся с исключением",
		990: "Ваш аккаунт был заморожен из-за невыполненных заданий в течение длительного времени",
		10030008: "Пожалуйста, верните фонд помощи до подачи заявки на получение наличных денег",
		10030010: "Код приглашения не существует",
		10030011: "Превышено максимальное количество раз входа",
		10030012: "Не соответствует условиям входа, выполните задачу сначала",
		10030013: "Ошибка конфигурации входа, обратитесь в службу поддержки",
		10030014: "Не в пределах разрешенного времени",
		10030015: "Пользователь не существует",
		10030016:
			"Уважаемый пользователь: Поздравляем! Вы успешно завершили 100% продвижения вашего продукта. Пожалуйста, свяжитесь со службой поддержки платформы, чтобы запросить сброс.",
		10030017: "Невозможно сопоставить продукт, обратитесь в службу поддержки",
		10030018: "Недостаточный баланс на счете",
		10030019: "Учетная запись отключена",
		10030020: "Торговля запрещена для учетной записи",
		10030021: "Запрет на вывод средств с учетной записи",
		10030022: "Ошибка пароля транзакции",
		10030023: "Счет для вывода не привязан, привяжите счет для вывода средств сначала",
		10030024: "Ошибка старого пароля",
		10030027: "Ваш вывод ограничен. Пожалуйста, свяжитесь с службой поддержки для получения дополнительной информации",
		10030028: "Низкий кредитный рейтинг мешает вам снимать деньги",
		10030030: "Не в пределах разрешенного времени",
		10030031: "Обратитесь в службу поддержки, чтобы сбросить сегодняшнее задание",
		10030050: "Заказ истек. Пожалуйста, свяжитесь с службой поддержки клиентов для помощи."
	},
	errorHandler: {
		InternalError: "Внутренняя ошибка в движке JavaScript",
		ReferenceError: "Объект не найден",
		TypeError: "Неправильный тип или использование объекта",
		RangeError: "Параметр вне диапазона при использовании встроенных объектов",
		SyntaxError: "Синтаксическая ошибка",
		EvalError: "Неправильное использование Eval",
		URIError: "Ошибка URI",
		UnknownError: "Неизвестная ошибка"
	},
	Network: {
		timedout: "Время запроса истекло! Пожалуйста, попробуйте еще раз позже",
		error: "Ошибка сети! Пожалуйста, попробуйте еще раз позже"
	},
	request: {
		NoMoreData: "Больше данных нет",
		OnlyImage: "Пожалуйста, загружайте только файлы изображений.",
		FileMaxSize: "Размер файла превышает максимальное значение, которое составляет {0}M"
	},
	response: {
		loading: "Загрузка",
		success: "Успешно",
		fail: "Неудача",
		complete: "Завершено"
	},
	page: {
		noVerify: "Кошелёк не подтверждён, пожалуйста, сначала подтвердите кошелёк",
		notexist: "Извините, страница, которую вы пытаетесь открыть, не существует~"
	}
};
